import * as React from "react";
import { ILineItem } from "../models/ILineItem.model";

function TradePrice(props: ILineItem) {

	return (
		<div className="c-price c-price--trade">
			<p className={`c-price__intro ${props.IsOnSale ? " c-price__intro--sale" : ""}`}>Your trade price</p>
			<p className={`c-price__main ${props.IsOnSale ? "c-price__main--sale" : ""}`} data-test="basket-item-price" data-test-item-price-per-item={props.Price.Formatted}>
				<span data-test="basket-line-item-total">{props.LineTotal.Formatted}</span>
				{" "}
				<span className="u-small">inc. VAT</span>
			</p>
			<div className="c-price__comparison-was-container">
				<span className={`c-price__comparison ${props.IsOnSale ? "c-price__comparison--by-was" : ""}`}>
					Retail <span data-test="product-price-retail" data-test-retail-price-per-item={`${props.RetailPrice.Formatted}`}>{props.LineRetail.Formatted}</span>
				</span>
				{props.IsOnSale ?
					<span className="c-price__was">
						Was <span className="c-price__was-price" data-test="product-price-was" data-test-was-price-per-item={`${props.OriginalPrice.Formatted}`}>{props.LineWas.Formatted}</span>
					</span>
					: null}
			</div>
		</div>
	);
}

export default TradePrice;
